<div class="p-6 max-w-xl mx-auto text-center">
    <h1 class="text-2xl font-semibold mb-2">Vous êtes déconnecté</h1>
    <p class="mb-6">Votre session a été fermée. Vous pouvez vous reconnecter pour continuer.</p>
    <a class="underline" href="/">Se reconnecter</a>
</div>
